import { AutoPaymentsDebtsAction, AutoPaymentsDebtsState } from "./autoPayments.debts.types";

export const autoPaymentsDebtsRequestAction = (): AutoPaymentsDebtsAction => ({ type: 'AUTO_PAYMENT_DEBTS_REQUEST' })

export const autoPaymentsDebtsSuccessAction = (debts: AutoPaymentsDebtsState['debts']): AutoPaymentsDebtsAction => ({ type: 'AUTO_PAYMENT_DEBTS_SUCCESS', params: debts })

export const autoPaymentsDebtsFailureAction = (error?: any): AutoPaymentsDebtsAction => ({ type: 'AUTO_PAYMENT_DEBTS_FAILURE', params: error })